import {
  canUseLegacyProductSelection,
  hasPersistedProductSelection,
  serializeProductSelectionDraft
} from './adapters';
import { validateProductSelectionDraft } from './validators';
import type {
  PhysicalSamplingConfig,
  ProductSelectionDraft,
  ProductSelectionSubmit
} from './types';

type SubmissionResult =
  | 'SAVED'
  | 'UNAVAILABLE'
  | 'REFRESH_FAILED'
  | 'INVALID'
  | 'STALE';

export const submitProductSelection = async ({
  config,
  draft,
  submitLegacy,
  submitSelection,
  refresh,
  isCurrent = () => true
}: {
  config: PhysicalSamplingConfig;
  draft: ProductSelectionDraft;
  submitLegacy: (
    skuList: Array<{ label: string; value: string }>
  ) => Promise<void>;
  submitSelection?: ProductSelectionSubmit;
  refresh: () => Promise<unknown>;
  isCurrent?: () => boolean;
}): Promise<SubmissionResult> => {
  if (!isCurrent()) return 'STALE';
  if (validateProductSelectionDraft(config, draft).length) return 'INVALID';
  const payload = serializeProductSelectionDraft(config, draft);
  if (canUseLegacyProductSelection(config)) await submitLegacy(payload.skuList);
  else if (submitSelection) await submitSelection(payload.productSelection);
  else return 'UNAVAILABLE';
  if (!isCurrent()) return 'STALE';
  let detail: unknown;
  try {
    detail = await refresh();
  } catch {
    return isCurrent() ? 'REFRESH_FAILED' : 'STALE';
  }
  if (!isCurrent()) return 'STALE';
  return detail && hasPersistedProductSelection(config, draft, detail)
    ? 'SAVED'
    : 'REFRESH_FAILED';
};
